import script from "./BreathDots.vue?vue&type=script&setup=true&lang=js"
export * from "./BreathDots.vue?vue&type=script&setup=true&lang=js"

import "./BreathDots.vue?vue&type=style&index=0&id=6d21072b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d21072b"]])

export default __exports__